export const detectLiquidityZones = (data, persistenceThreshold, stdDevMultiplier, candleRange = 4) => {
  const liquidityZones = []; // Keeps the nomenclature for future expansion

  // Helper function to calculate mean and standard deviation
  const calculateStats = (subset) => {
    const mean = subset.reduce((sum, candle) => sum + candle.close, 0) / subset.length;
    const variance =
      subset.reduce((sum, candle) => sum + Math.pow(candle.close - mean, 2), 0) / subset.length;
    const stdDev = Math.sqrt(variance);
    return { mean, stdDev };
  };

  let lowestPrice = Infinity;
  let reversalPoint = null;
  let startTime = null;
  let endTime = null;
  let avgVolume = 0;

  console.log("Starting liquidity zone detection...");

  // Evaluate the entire dataset for the lowest price and corresponding reversal
  for (let i = candleRange - 1; i < data.length; i++) {
    // Extract a rolling window of candles
    const subset = data.slice(i - candleRange + 1, i + 1);
    const { mean, stdDev } = calculateStats(subset);

    console.log(`Subset from ${subset[0].time} to ${subset[subset.length - 1].time}`);
    console.log(`Mean: ${mean.toFixed(4)}, StdDev: ${stdDev.toFixed(4)}`);

    let persistence = 0;

    // Check for demand zone within the rolling window
    for (let j = 0; j < candleRange; j++) {
      const candle = subset[j];

      console.log(`Evaluating candle at ${candle.time} - Low: ${candle.low}, Close: ${candle.close}`);

      // Identify the lowest price in the entire dataset
      if (candle.low < lowestPrice) {
        lowestPrice = candle.low;
        startTime = candle.time; // Set the start time for the lowest price
        console.log(`New lowest price found: ${lowestPrice} at ${startTime}`);
      }

      // Check for a reversal point significantly above the lowest price
      if (candle.close > lowestPrice + stdDevMultiplier * stdDev) {
        persistence++;
        reversalPoint = candle.close; // Set the reversal point
        endTime = candle.time; // Set the end time of the reversal
        console.log(`Reversal point detected: ${reversalPoint} at ${endTime}`);
      }

      if (persistence >= persistenceThreshold) {
        avgVolume = subset.reduce((sum, c) => sum + c.volume, 0) / candleRange;
        console.log(`Persistence threshold met with ${persistence} candles.`);
        break;
      }
    }
  }

  // Define the demand zone if conditions are met
  if (lowestPrice < Infinity && reversalPoint !== null) {
    liquidityZones.push({
      startTime, // Start of the zone
      endTime, // End of the zone
      proximal: reversalPoint, // Reversal point (top of the zone)
      distal: lowestPrice, // Lowest price (bottom of the zone)
      width: parseFloat((reversalPoint - lowestPrice).toFixed(4)), // Zone width
      type: "demand", // Zone type
      persistence: persistenceThreshold, // Persistence threshold met
      avgVolume: parseFloat(avgVolume.toFixed(2)), // Average volume within the zone
    });

    console.log("Demand zone created:", liquidityZones[0]);
  } else {
    console.log("No demand zone detected.");
  }

  return { liquidityZones };
};
